export enum PackagingType {
  SINGLE_UNIT_PACKAGING = "single-unit",
  BULK_UNIT_PACKAGING = "bulk-unit",
  TRANSPORT_UNIT_PACKAGING = "transport-unit",
  SALES_UNIT_PACKAGING = "sales-unit"
}
